<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <participants-list :participants="participants" :remove-action="true" v-on="$listeners" />
      </div>

      <div v-if="!newParticipant" class="col-sm-12 mt-3 pt-3 border-top">
        <div class="form-group float-right">
          <base-button cy-id="add-participant" native-type="submit" type="default" @click="newParticipant = true">
            Agregar Participante
          </base-button>
        </div>
      </div>

      <div v-if="newParticipant" class="col-sm-12 mt-3 pt-3 border-top">
        <h4>Agregue un participante</h4>

        <div class="form-group mt-3">
          <label class="control-label">Seleccione tipo de participante</label>

          <el-select
            v-model="formData.type"
            cy-id="participant-type"
            autocomplete="off"
            filterable
            name="participantType"
            placeholder="Seleccione Tipo (*)"
            @change="formData.entity = null"
          >
            <el-option v-for="option in typesOptions" :key="option.value" :label="option.label" :value="option">
            </el-option>
          </el-select>
        </div>

        <div v-if="formData.type !== null" class="form-group">
          <label class="control-label d-block">Seleccione {{ formData.type.label }}</label>

          <el-autocomplete
            v-model="formData.selectedEntity"
            cy-id="select-participant"
            :fetch-suggestions="querySearchAsync"
            :placeholder="formData.type.label"
            name="participant"
            @select="handleSelect"
          ></el-autocomplete>

          <small v-show="searchError !== ''" class="text-danger d-block">
            {{ searchError }}
          </small>
        </div>

        <div class="form-group float-right">
          <base-button
            :disabled="formData.entity === null"
            cy-id="add-participant"
            type="success"
            @click="addParticipant"
          >
            Agregar
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Autocomplete, Select, Option } from 'element-ui';
import ParticipantsList from '@/views/Visits/List/ParticipantsList';
import remoteAutocompleteMixin from '../../../mixins/remoteAutocompleteMixin';

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Autocomplete.name]: Autocomplete,
    ParticipantsList,
  },

  mixins: [remoteAutocompleteMixin],
  props: {
    participants: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      sellers: [],
      distributors: [],
      producers: [],
      formData: {
        type: null,
        entity: null,
        selectedEntity: null,
      },

      newParticipant: false,
      participantTypes: [
        {
          value: 'sellers',
          label: 'Asesor Técnico',
        },
        {
          value: 'producers',
          label: 'Productor',
        },
        {
          value: 'distributors',
          label: 'Distribuidor',
        },
      ],
    };
  },

  computed: {
    typesOptions() {
      return this.participantTypes.filter((i) => this.$can('index', i.value));
    },
  },

  methods: {
    addParticipant() {
      this.$emit('add-participant', {
        id: this.formData.entity.id,
        name: this.formData.entity.value,
        type: this.formData.type.value,
        typeToShow: this.formData.type.label,
        principal: false,
      });

      this.newParticipant = false;
      this.formData.type = null;
      this.formData.entity = null;
      this.formData.selectedEntity = null;
    },

    fetchData(query) {
      if (this.formData.type.value === 'producers') {
        return this.fetchProducers(query);
      } else if (this.formData.type.value === 'sellers') {
        return this.fetchSellers(query);
      } else if (this.formData.type.value === 'distributors') {
        return this.fetchDistributors(query);
      }
    },

    selectOptions() {
      if (this.formData.type.value === 'producers') {
        return this.producers;
      } else if (this.formData.type.value === 'sellers') {
        return this.sellers.map((item) => ({
          id: item.id,
          value: item.name,
        }));
      } else if (this.formData.type.value === 'distributors') {
        return this.distributors;
      }
      return [];
    },

    fetchProducers(query) {
      this.producers = [];
      if (this.$can('index', 'producers')) {
        return this.$services
          .resource('producers')
          .search({ query })
          .then((res) => res.data.data)
          .then((producers) => (this.producers = producers));
      }
    },

    fetchSellers(query) {
      this.sellers = [];
      if (this.$can('index', 'sellers')) {
        return this.$services
          .resource('sellers')
          .get({ 'filter[search]': query, sort: 'name' })
          .then((res) => res.data.data)
          .then((data) => (this.sellers = data.sellers));
      }
    },

    fetchDistributors(query) {
      this.distributors = [];
      if (this.$can('index', 'distributors')) {
        return this.$services
          .resource('distributors')
          .search({ query })
          .then((res) => res.data.data)
          .then((distributors) => (this.distributors = distributors));
      }
    },
  },
};
</script>

<style scoped>
.el-autocomplete {
  width: 100%;
}
</style>
